export default __webpack_public_path__ + "static/San-Diego-505c0af05a956d76891ad28f07861ba6.webp";